import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IPackage } from "../packageModel";
import moment from "moment";

export const getAllPackages = createAsyncThunk(
  "Package/FindAllPackage",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Package/FindAllPackage`,
        {},
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Packages:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createPackage = createAsyncThunk(
  "Package/InsertPackage",
  async (PackageData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Package/InsertPackage`,
        PackageData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Package:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updatePackage = createAsyncThunk(
  "Package/UpdatePackage",
  async (PackageData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Package/UpdatePackage`,
        PackageData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Package:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deletePackage = createAsyncThunk(
  "Package/DeletePackage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Package/DeletePackage`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Package :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getPackageByID = createAsyncThunk(
  "Package/FindByIDPackage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Package/FindByIDPackage`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        PackageTitle: result?.PackageTitle,
        PackageURL: result?.PackageURL,
        City: result?.City,
        ValidityPeriod: result?.ValidityPeriod
          ? moment(result?.ValidityPeriod, "YYYY-MM-DD").toDate()
          : "",
        PackageInclusion: result?.PackageInclusion || "",
        ChildPolicy: result?.ChildPolicy || "",
        CancellationPolicy: result?.CancellationPolicy || "",
        CheckinCheckoutInfo: result?.CheckinCheckoutInfo || "",
        FreeTitle: result?.FreeTitle || "",
        IsFree: result?.IsFree || false,
        MetaTitle: result?.MetaTitle,
        MetaKeywords: result?.MetaKeywords,
        MetaDescription: result?.MetaDescription,
        Roompricingdetails: result?.Roompricingdetails
          ? result?.Roompricingdetails?.map((room: any) => {
              return {
                ...room,
                OneNightRate: room?.OneNightRate ? +room?.OneNightRate : 0,
                TwoNightRate: room?.TwoNightRate ? +room?.TwoNightRate : 0,
              };
            })
          : [],
        MainImage: result?.MainImage,
        BannerImage: result?.BannerImage,
        IsActive: result.IsActive ? 1 : 2,
      } as IPackage;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Package :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActivePackages = createAsyncThunk(
  "Package/FindAllActivePackage",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Package/FindAllActivePackage`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Packages:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactivePackage = createAsyncThunk(
  "Package/ActiveInActivePackage",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Package/ActiveInActivePackage`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Package :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD
export const PackageImageUpload = createAsyncThunk(
  "Package/PackageImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Package/PackageImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Package Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
